import { BADGE_POSITIONS,withTooltip,IconNotification, Badge } from 'cdk-radial';
import {useNotificationStore} from '../../Store';
import { useTranslation } from 'react-i18next';
import * as Styles from './styles';
import { generateTooltipProps } from './Header';
import {useMemo} from 'react';

const IconNotificationButton = (props: {
    onClick: Function
  }) => {
  
  const { t } = useTranslation();

  const HeaderNotificationIcon = useMemo(() => {
      const tooltipProps = generateTooltipProps('Notifications', t('notification.toolTip'));
            return withTooltip(Styles.HeaderButton, tooltipProps);
        }, [t]);

  const count = useNotificationStore((state:any) => state.count);
  const unreadCount = useNotificationStore((state:any) => state.unreadCount);
  const setshouldNotificationRefresh = useNotificationStore((state:any) => state.setshouldNotificationRefresh);
  
  const onClickHandler = (event:any) => {
    setshouldNotificationRefresh(true);
    props.onClick(event);
  }

  return (
    <div>
      {count > 0 && <div style={{ position: 'relative', display: 'inline-block' }} tabIndex={-1}><HeaderNotificationIcon
        onClick={onClickHandler}
        backgroundAppearance={'dark'}
        icon={<IconNotification />}
        text={t('header.notification')}
        dataTestId="header-icon-notification"
        tabIndex={0}
        id="notificationButton"
      /><Badge tabIndex={-1} children={count > 99 ? '99+' : count}
        position={BADGE_POSITIONS.RIGHT}
        badgeColor={unreadCount > 0 ? '#EB0C00' : '#4D4D4D'} style={{
          position: 'absolute',
          top: '3px',
          right: '3px',
          transform: 'translate(50%, -50%)',
          pointerEvents: 'none',
        }}></Badge> </div>}
      {count === 0 &&
        <HeaderNotificationIcon
          onClick={onClickHandler}
          backgroundAppearance={'dark'}
          icon={<IconNotification />}
          text={t('header.notification')}
          dataTestId="header-icon-notification"
          tabIndex={0}
          id="notificationButton"
        />}
    </div>
  );
};

export default IconNotificationButton;